import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: '',
    description: 'Page header',
    defaultMessage: 'Choose folder for signed copy',
  },
  filenameLabel: {
    id: '',
    description: 'Label for filename input',
    defaultMessage: 'File name of copy',
  },
  folderLabel: {
    id: '',
    description: 'Label for folder',
    defaultMessage: 'Folder',
  },
  folderSelectionError: {
    id: '',
    description: 'Error message when a folder for saving the file is not selected',
    defaultMessage: 'Access to this folder is restricted. Please choose a different folder.',
  },
});
